import { render, staticRenderFns } from "./feijiaobookth.vue?vue&type=template&id=241f59c2&scoped=true&"
import script from "./feijiaobookth.vue?vue&type=script&lang=js&"
export * from "./feijiaobookth.vue?vue&type=script&lang=js&"
import style0 from "./feijiaobookth.vue?vue&type=style&index=0&id=241f59c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f59c2",
  null
  
)

export default component.exports